<template>
    <div class="cmp cmp-method-list list mb-4" v-bind:class="{ 'error': showError }">
        <ul class="method-list component-loading" :class="{ 'is-loading': isBasketLoading || isCheckoutReadonly }">
            <li v-for="shippingProfile in shippingProfileList" class="method-list-item"
                :data-id="shippingProfile.parcelServicePresetId">
                <input type="radio" :id="'ShippingProfileID' + _uid + shippingProfile.parcelServicePresetId"
                    :name="'shippingProfileSelect' + _uid" :value="shippingProfile.parcelServicePresetId"
                    @change="onShippingProfileChange(shippingProfile.parcelServicePresetId)"
                    :checked="shippingProfileId === shippingProfile.parcelServicePresetId"
                    :disabled="isBasketLoading || isCheckoutReadonly || (paymentContainerIsOverwritten && isPaymentMethodExcluded(shippingProfile, selectedPaymentMethodId))">
                <label class="provider-select-label"
                    :for="'ShippingProfileID' + _uid + shippingProfile.parcelServicePresetId" :class="paddingClasses"
                    :style="paddingInlineStyles"
                    v-tooltip="isPaymentMethodExcluded(shippingProfile, selectedPaymentMethodId)" data-toggle="tooltip"
                    data-placement="top"
                    :data-title="getTooltip(shippingProfile.parcelServicePresetId, selectedPaymentMethodId)">
                    <span class="icon mh-60" :class="{ 'w-33 ml-8': shippingProfile.parcelServicePresetId == 29 }">
                        <template v-if="shippingProfile.parcelServicePresetId == 7">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-fedex"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 8">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 9">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 12">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-fedex"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 13">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-collect"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 15">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5"><!-- class="scale-2-5" -->
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 16">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-fedex"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 17">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 18" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>
                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 20" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 21">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-collect"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 22">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 23">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 24">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>
                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 25" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>
                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 26" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>
                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 27" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>
                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 28" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>
                        <!--                        <lazy-img-->
                        <!--                                v-else-if="shippingProfile.parcelServicePresetId == 29"-->
                        <!--                                picture-class="img-fluid fit-contain"-->
                        <!--                                image-url="https://cdn03.plentymarkets.com/ioseuwg7moqp/frontend/od_3dprima_v2/shipping/DPD_symbol_red_rgb.png"-->
                        <!--                                alt="PostNord">-->
                        <!--                        </lazy-img>-->


                        <template v-else-if="shippingProfile.parcelServicePresetId == 29">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#DPD"></use>
                            </svg>
                        </template>

                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 30" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>
                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 31" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 32">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>

                        <lazy-img v-else-if="shippingProfile.parcelServicePresetId == 33" picture-class="img-fluid"
                            :image-url="pluginPath + '/images/postnord.svg'" alt="PostNord">
                        </lazy-img>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 35">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 36">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 37">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>

                        <!--                        <lazy-img-->
                        <!--                                v-else-if="shippingProfile.parcelServicePresetId == 38"-->
                        <!--                                picture-class="img-fluid fit-contain"-->
                        <!--                                image-url="https://cdn03.plentymarkets.com/ioseuwg7moqp/frontend/od_3dprima_v2/shipping/kliche-sparbart-brev-utrikes-post-expr.png"-->
                        <!--                                alt="Post Express">-->
                        <!--                        </lazy-img>-->

                        <template v-else-if="shippingProfile.parcelServicePresetId == 38">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#post-expres"></use>
                            </svg>
                        </template>


                        <template v-else-if="shippingProfile.parcelServicePresetId == 39">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dao-logo"></use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 40">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 41">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dao-logo"></use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 43">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl-express">
                                </use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 44">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl-express">
                                </use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 45">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl-express">
                                </use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 46">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 47">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 48">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 49">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 50">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl-express">
                                </use>
                            </svg>
                        </template>

                        <template v-else-if="shippingProfile.parcelServicePresetId == 51">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl-express">
                                </use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 52">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 53">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 54">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dhl"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 57">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mh-32">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#budbee-shipping"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 58">
                            <svg xmlns="http://www.w3.org/2000/svg" class="">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#budbee-shipping"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 59">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 60">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dachser"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 61">
                            <svg xmlns="http://www.w3.org/2000/svg" class="scale-2-5">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-ups"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 62">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-collect"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 63">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#DPD"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 64">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#DPD"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 65">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#DPD"></use>
                            </svg>
                        </template>
                        <template v-else-if="shippingProfile.parcelServicePresetId == 66">
                            <svg xmlns="http://www.w3.org/2000/svg">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#shipping-dsv"></use>
                            </svg>
                        </template>

                        <lazy-img v-else v-if="shippingProfile.icon" picture-class="img-fluid"
                            :image-url="shippingProfile.icon" :alt="shippingProfile.parcelServiceName"
                            :title="shippingProfile.parcelServiceName">
                        </lazy-img>
                    </span>
                    <span class="d-inline-block pl-1 pr-1 mw-40 text-center position-relative">
                        <template
                            v-if="$translate('OD3dprimaV2::Template.checkoutShippingProfile' + shippingProfile.parcelServicePresetId) !== ''
                                && $translate('OD3dprimaV2::Template.checkoutShippingProfile' + shippingProfile.parcelServicePresetId) !== 'OD3dprimaV2::Template.checkoutShippingProfile' + shippingProfile.parcelServicePresetId">
                            {{
                                $translate('OD3dprimaV2::Template.checkoutShippingProfile' +
                                    shippingProfile.parcelServicePresetId)
                            }}
                        </template>
                        <template v-else>
                            {{ shippingProfile.parcelServiceName }}
                        </template>
                    </span>
                    <small class="checkout__shipping-price">
                        {{ shippingProfile.shippingAmount | currency }}
                    </small>
                </label>
                <popper trigger="hover" placement="bottom"
                    :body-class="shippingProfile.parcelServicePresetName || (maxDeliveryDays && maxDeliveryDays[shippingProfile.parcelServicePresetId]) ? '' : 'd-none'">
                    <template #handle>
                        <span class="checkout__popover">i</span>
                    </template>
                    <template #title>
                        {{ shippingProfile.parcelServiceName }}
                    </template>
                    <template #content>
                        <div>
                            {{ shippingProfile.parcelServicePresetName }} <br>
                            <template v-if="maxDeliveryDays && maxDeliveryDays[shippingProfile.parcelServicePresetId]">
                                - {{ $translate("Ceres::Template.checkoutShippingProfileMaxDeliveryDays", {
                                    "days":
                                        maxDeliveryDays[shippingProfile.parcelServicePresetId]
                                }) }}
                            </template>
                        </div>
                    </template>
                </popper>
            </li>
            <li v-if="shippingProfileList.length <= 0" class="method-list-item has-error">
                <div class="label">
                    <div class="content">
                        {{ $translate("Ceres::Template.notificationsCalculateShippingFailed") }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import TranslationService from "ceres/app/services/TranslationService";
import { mapState } from "vuex";
import { isDefined } from "ceres/app/helper/utils";

const NotificationService = require("ceres/app/services/NotificationService");

export default {

    props:
    {
        template:
        {
            type: String,
            default: "#vue-shipping-profile-select"
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        paymentContainerIsOverwritten:
        {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            pluginPath: App.pluginPath3DPrima
        }
    },

    computed: mapState({
        shippingProfileList: state => state.checkout.shipping.shippingProfileList,
        maxDeliveryDays: state => state.checkout.shipping.maxDeliveryDays,
        shippingProfileId: state => state.checkout.shipping.shippingProfileId,
        showError: state => state.checkout.validation.shippingProfile.showError,
        isBasketLoading: state => state.basket.isBasketLoading,
        isCheckoutReadonly: state => state.checkout.readOnly,
        selectedPaymentMethodId: state => state.checkout.payment.methodOfPaymentId
    }),

    /**
     * Add a shipping provider
     * Initialise the event listener
     */
    created() {
        this.$store.commit("setShippingProfileValidator", this.validate);
    },

    methods:
    {
        /**
         * Method on shipping profile changed
         */
        onShippingProfileChange(shippingProfileId) {
            this.$store.dispatch("selectShippingProfile", this.shippingProfileList.find(shippingProfile => shippingProfile.parcelServicePresetId === shippingProfileId))
                .then(data => {
                    document.dispatchEvent(new CustomEvent("afterShippingProfileChanged", { detail: this.shippingProfileId }));
                },
                    error => {
                        console.log("error");
                    });

            this.validate();
        },

        validate() {
            const showError = this.shippingProfileId <= 0 || this.shippingProfileList.length <= 0;

            this.$store.commit("setShippingProfileShowError", showError);

            if (showError) {
                NotificationService.error(
                    TranslationService.translate("Ceres::Template.checkoutCheckShippingProfile")
                );
            }
        },

        getTooltip(shippingProfileId, methodOfPaymentId) {
            let translationKey = "";

            const params = {};

            for (let i = 0; i < this.shippingProfileList.length; i++) {
                const shippingProfile = this.shippingProfileList[i];

                if (shippingProfile.parcelServicePresetId === shippingProfileId) {
                    if (this.paymentContainerIsOverwritten) {
                        translationKey = "Ceres::Template.checkoutChangePaymentMethodToHint";
                        params.paymentMethodNames = shippingProfile.allowedPaymentMethodNames.join(",");
                    } else {
                        translationKey = "Ceres::Template.checkoutChangePaymentMethodHint";
                    }
                    break;
                }
            }

            return TranslationService.translate(translationKey, params);
        },

        isPaymentMethodExcluded(shippingProfile, selectedPaymentMethodId) {
            if (isDefined(shippingProfile.excludedPaymentMethodIds)) {
                return shippingProfile.excludedPaymentMethodIds.includes(selectedPaymentMethodId);
            } else {
                return false;
            }
        }
    }
};
</script>
</script>
